import { render, staticRenderFns } from "./left_outer_thigh_f.vue?vue&type=template&id=74a4a3fd"
import script from "./left_outer_thigh_f.vue?vue&type=script&lang=js"
export * from "./left_outer_thigh_f.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports